import React from "react";

const DeveloperStad = () => {
  return (
    <div className='developer-stad-content'>
      <h2>Dashboard </h2>

      <div className='developer-stad-content-item'>
        <div className='developer-stad-box'>
          <h4>
            Developer Contacted : <span>12</span>
          </h4>
          <div className='developer-stad-item'></div>
        </div>
        <div className='developer-stad-box'>
          <h4>
            Developer Intersted : <span>9</span>
          </h4>
          <div className='developer-stad-item'></div>
        </div>
        <div className='developer-stad-box'>
          <h4>Developer Hired : 6</h4>
          <div className='developer-stad-item'></div>
        </div>
      </div>
    </div>
  );
};

export default DeveloperStad;
